import { render } from "./SectionEditorModal.vue?vue&type=template&id=454af1ea&scoped=true"
import script from "./SectionEditorModal.vue?vue&type=script&lang=js"
export * from "./SectionEditorModal.vue?vue&type=script&lang=js"

import "./SectionEditorModal.vue?vue&type=style&index=0&id=454af1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454af1ea"]])

export default __exports__